import React, { useEffect, useRef, useState } from "react";
import "./componentStyles.css";
import AdvancedFilter from "../../../filter/AdvancedFilter";
import SearchBox from "../../../search/AdvancedSearch";
import CustomPagination from "../../../pagination/AdvancedPagination1";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { FaList, FaThLarge } from "react-icons/fa";
import HeaderLayout2 from "./PageHeader2";
import { CheckCircleIcon, SaveIcon } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterData, setPaginationData, setSearchInput } from "../payrollSlice";
import { categoryOptions } from "../payrollEnums";

const PageHeader = ({
  isGridView,
  setIsGridView,
  handleCreateBtn,
  pageName,
  headerLayout,
  handleBack,
  handleEdit,
  handleSave,
  newData,
  generatePayslip,
  handleGeneratePayslip,
  gridView,
  filter = true,
  searchBox = true,
  createBtn = true,
  pagination = true,
  actionBtn = true,
  saveBtn,
  success,
  saveBtnLoading,
  isLoading,
  filterOptions,
  categoryOptions,
  postBtn,
  handlePost,
  status,
  returnToDraft,
  computePayslip ,
  handleComputePayslip,
  handleResetToDraft,
  editBtn,
  headerLeftExtra,
  headerRightExtra,
  deleteBtn,
  handleDelete
}) => {
  const dispatch = useDispatch();
  const childRef = useRef();
  // const { paginationData } = useSelector((state) => state.payrollSlice);
    const { paginationData = { currentPage: 1, totalPages: 1 } } = useSelector(
    (state) => state.payrollSlice || {}
  );
  //  filter submission
  const handleFilterSubmission = (data) => {
    dispatch(setFilterData(data));
  };
  //handle layout change
  const handleLayoutChange = () => {
    try {
      setIsGridView(!isGridView);
    } catch (err) {
      throw new Error("Failed to change layout. Please try again.");
    }
  };

  //handle pagination
  const onPageChange = (pageNumber) => {
    console.log(pageNumber)
    dispatch(setPaginationData({ currentPage: pageNumber, totalPages: paginationData.totalPages }));
  };

  // handle search 

  const handleSearch = (searchValue) => {

    dispatch(setSearchInput(searchValue));
  };

  return (
    <header className="new-section-header">
      <div className="new-section-header__content">
        {headerLayout === 1 ? (
          <>
            <div className="new-section-header__filter">
              {filter && (
                <AdvancedFilter
                  handleFilter={handleFilterSubmission}
                  filterOptions={filterOptions}
                  categoryOptions={categoryOptions}
                  ref={childRef}
                />
              )}
              {searchBox && <SearchBox handleSearch={handleSearch} suggestion={false} suggestionData={[]} />}
              {createBtn && (
                <button
                  onClick={() => handleCreateBtn()}
                  className="new-section-header__create-button"
                >
                  Create
                </button>
              )}
            </div>
          </>
        ) : (
          <>
            <HeaderLayout2
              actionBtn={actionBtn}
              handleGeneratePayslip={handleGeneratePayslip}
              generatePayslip={generatePayslip}
              handleEdit={handleEdit}
              handleSave={handleSave}
              handleBack={handleBack}
              newData={newData}
              isLoading={isLoading}
              postBtn={postBtn}
              handlePost={handlePost}
              status={status}
              returnToDraft={returnToDraft}
              computePayslip ={computePayslip}
              handleComputePayslip={handleComputePayslip}
                handleResetToDraft={handleResetToDraft}
                editBtn={editBtn}
                headerLeftExtra={headerLeftExtra}
                headerRightExtra={headerRightExtra}
                deleteBtn={deleteBtn}
                handleDelete={handleDelete}

            />
          </>
        )}
      </div>

      <div className="new-section-header__pagination">
        {headerLayout === 1 ? (
          <>
            <strong style={{ margin: 0, fontSize: "25px", fontWeight: "500" }}>
              {pageName}
            </strong>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {gridView && (
                <IconButton
                  onClick={handleLayoutChange}
                  aria-label={
                    isGridView ? "Switch to list view" : "Switch to grid view"
                  }
                  sx={{ p: 1 }}
                >
                  {isGridView ? <FaList size={15} /> : <FaThLarge size={15} />}
                </IconButton>
              )}
              {pagination && (
                <CustomPagination
                  totalPages={paginationData.totalPages || 0}
                  onPageChange={onPageChange}
                />
              )}
            </div>
            {saveBtn && (
              <Tooltip title="Save">
                <IconButton
                  color={success ? "success" : "primary"}
                  onClick={handleSave}
                  disabled={saveBtnLoading}
                  aria-label="save"
                  size="large"
                >
                  {saveBtnLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : success ? (
                    <CheckCircleIcon />
                  ) : (
                    <SaveIcon />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </header>
  );
};

export default PageHeader;
